import Moment from 'react-moment';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../../app/redux/hooks';
import { LoyaltyType } from '../../api';
import {
  useIsTrainingMode,
  useOperatorSession,
  useOutstandingDispenseCount,
  usePendingDispenseCount,
  useReadyToServeCount,
  useWorkstation,
} from '../../appState';
import { useOfflineMode } from '../../config';
import { setSidebarState, useShowSidebar, useTransaction } from '../orderSlice';

import Sidebar from './Sidebar';

export function Header() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const workstation = useWorkstation();
  const operatorSession = useOperatorSession();
  const showSidebar = useShowSidebar();
  const transaction = useTransaction();
  const isTrainingMode = useIsTrainingMode();
  const isOfflineMode = useOfflineMode();
  const pendingDispenseCount = usePendingDispenseCount();
  const readyToServeCount = useReadyToServeCount();
  const outstandingDispenseCount = useOutstandingDispenseCount();

  const primaryTransaction = transaction.length > 0 ? transaction[0] : undefined;
  return (
    <>
      {isTrainingMode && <div className="training-mode-banner">TRAINING MODE</div>}
      {isOfflineMode === false && workstation?.offlineAvailable === false && (
        <div className="offline-backup-banner">Offline backup unavailable — call support</div>
      )}
      <div className="pos-header pos-header_role_main">
        <div className="pos-header__area pos-header__area_role_info">
          <div className="pos-header__info">
            <button
              className="pos-header__sidebar-toggle js-sidebar-toggle"
              type="button"
              onClick={() => dispatch(setSidebarState(!showSidebar))}
            >
              Toggle Sidebar
            </button>
            <div className="pos-header__labels">
              <div className="pos-header__label">Till No. {workstation?.terminalNumber}</div>
              <div className="pos-header__label">
                {isOfflineMode && <span className="offline-mode-indicator">{operatorSession?.operator.lastName.substring(4)}</span>}
                {isOfflineMode === false && (
                  <span>
                    {operatorSession?.operator.firstName} {operatorSession?.operator.lastName.substring(0, 1)}
                  </span>
                )}
              </div>
              <div className="pos-header__label">
                <Moment interval={1000} format="ddd DD-MM-yyyy" />
              </div>
              <div className="pos-header__label">
                <Moment interval={1000} format="HH:mm:ss" />
              </div>
              {pendingDispenseCount > 0 && (
                <button
                  className="pos-header__dispense-badge"
                  type="button"
                  onClick={() => navigate('./failed-prints')}
                  title="View pending dispense orders"
                >
                  <span className="pos-header__dispense-count pos-header__dispense-count_role_pending">{pendingDispenseCount}</span>
                </button>
              )}
              <button
                className="pos-header__dispense-badge"
                type="button"
                onClick={() => navigate('./outstanding-dispense')}
                title="View outstanding dispense orders from this till"
              >
                <span className="pos-header__dispense-count pos-header__dispense-count_role_outstanding">{outstandingDispenseCount}</span>
              </button>
              <button
                className="pos-header__dispense-badge"
                type="button"
                onClick={() => navigate('./ready-to-serve')}
                title="View ready to serve orders"
              >
                <span className="pos-header__dispense-count pos-header__dispense-count_role_ready">{readyToServeCount}</span>
              </button>
            </div>
            {workstation?.isAppTill === false && (
              <button className="pos-header__search-toggle" type="button" onClick={() => navigate('./search')}>
                Search
              </button>
            )}
          </div>
        </div>
        <div className="pos-header__area pos-header__area_role_actions">
          <div className="pos-header__actions">
            {primaryTransaction?.isWaste === false && workstation?.isAppTill === false && isOfflineMode === false && (
              <>
                <button className="pos-header__action" type="button" onClick={() => navigate('./bookings')}>
                  Bookings
                </button>
                {primaryTransaction?.loyaltyType == LoyaltyType.None && isOfflineMode === false && (
                  <button
                    className="pos-header__action"
                    type="button"
                    onClick={() => navigate('./loyalty')}
                    disabled={primaryTransaction?.loyaltyType != LoyaltyType.None}
                  >
                    Loyalty
                  </button>
                )}{' '}
                {primaryTransaction?.loyaltyType == LoyaltyType.Customer && isOfflineMode === false && (
                  <button
                    className="pos-header__action"
                    type="button"
                    onClick={() => navigate(`./loyalty/details/${primaryTransaction?.id}`)}
                  >
                    Loyalty
                  </button>
                )}
                {workstation?.hideTables === false && isOfflineMode === false && (
                  <button className="pos-header__action" type="button" onClick={() => navigate('/tables')}>
                    Tables
                  </button>
                )}
              </>
            )}
            {primaryTransaction?.isWaste === true && <div className="waste-mode-banner">WASTE MODE</div>}
            {workstation?.isAppTill === true && <div className="waste-mode-banner">SELF SERVICE APP TILL</div>}
          </div>
        </div>
      </div>
      {showSidebar && <Sidebar />}
    </>
  );
}
